export const LOCALIZATION_TEXT = {
    LANGUAGE: 'Мова',
    TRANSLATIONS: 'Переклади',
    FILTER: {
        STATUS: {
            ALL: 'Усі',
            OUTDATED: 'Неактуальні',
            MISSING: 'Відсутні',
        },
    },
};
